module.exports = __webpack_public_path__ + "img/logo.e2079b7d.svg";